const getPricelineHotels = async (parameters) => {
  const { checkIn, checkOut, latitude, longitude, rooms, adults, children, amenities, hotelChain, hotelStar } = parameters;
  const params = `check_in=${checkIn}&check_out=${checkOut}&latitude=${latitude}&longitude=${longitude}&rooms=${rooms}&adults=${adults}&children=${children}&amenities=${amenities}&hotel_chain=${hotelChain}&hotel_star=${hotelStar}`;
  const url = `${process.env.API_URL}/hotel/search/list/?${params}`;
  const req = await fetch(url, { credentials: 'include' });
  return req;
};

const getForaHotels = async (parameters) => {
  const { checkIn, checkOut, latitude, longitude, rooms, adults, children, amenities, hotelChain, hotelStar, pageVip, limitVip, hotelName } = parameters;
  const params = `check_in=${checkIn}&check_out=${checkOut}&latitude=${latitude}&longitude=${longitude}&rooms=${rooms}&adults=${adults}&children=${children}&amenities=${amenities}&hotel_chain=${hotelChain}&hotel_star=${hotelStar}&limit=${limitVip}&offset=${pageVip}&hotel_name=${hotelName}`;
  const url = `${process.env.API_URL}/hotel/search/list-vip/?${params}`;
  const req = await fetch(url, { credentials: 'include' });
  return req;
};
export { getPricelineHotels, getForaHotels };
